import type { ExtractionReview } from "v2/types/extractionReview.types";

export const countReviewDocuments = (
  review: ExtractionReview | null | undefined
): number => {
  if (!review) return 0;

  const names = review.sections
    .flatMap((section) => section.fields)
    .flatMap((field) => field.candidates)
    .map((candidate) => candidate.source_doc_name)
    .filter((name): name is string => Boolean(name));

  return new Set(names).size;
};
